export const NOTES_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export type NotesQuota = {
  allowed: boolean;
  lastAt: string | null;
  retryAt: string | null;
};

export function notesQuotaFromLastAt(lastAt: string | null | undefined, now = Date.now()): NotesQuota {
  if (!lastAt) {
    return { allowed: true, lastAt: null, retryAt: null };
  }
  const lastMs = Date.parse(lastAt);
  if (Number.isNaN(lastMs)) {
    return { allowed: true, lastAt: null, retryAt: null };
  }
  const retryMs = lastMs + NOTES_COOLDOWN_MS;
  if (now >= retryMs) {
    return { allowed: true, lastAt, retryAt: null };
  }
  return { allowed: false, lastAt, retryAt: new Date(retryMs).toISOString() };
}

export function formatNotesWait(retryAt: string | null, now = Date.now()): string {
  if (!retryAt) return 'One set of notes per account each day.';
  const hours = Math.max(1, Math.ceil((Date.parse(retryAt) - now) / 3_600_000));
  if (hours <= 1) return 'Next notes in about an hour.';
  return `Next notes in ${hours} hours.`;
}

export function clerkFrontendApiFromPublishableKey(key: string): string {
  const encoded = key.replace(/^pk_(test|live)_/, '');
  const decoded = Buffer.from(encoded, 'base64').toString('utf8').replace(/\$$/, '').trim();
  if (!decoded.includes('clerk')) {
    throw new Error('Could not read the Clerk instance from the publishable key.');
  }
  return decoded;
}
